import React from "react";
import Select from "react-select";
import { FormField } from "react-form";
import Typography from "@material-ui/core/Typography";


const baseStyles = {
    control: (styles, state) => ({
        ...styles,
        backgroundColor: state.isDisabled ? "#EEEEEE" : "white",
        margin: "-1.5px",
        borderColor: state.isFocused ? "lightgreen" : "gray",
        "&:hover": { borderColor: state.isFocused ? "lightgreen" : "gray" },
        font: "15px",
        color: "#262626",
        boxShadow: "none",
        minHeight: 32,
    }),
    singleValue: (styles) => ({
        ...styles,
        fontSize: "15px",
        fontWeight: 500,
        color: "#262626 !important",
        fontFamily: "'Source Sans Pro', sans-serif",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 10000000 }),
    container: (styles, state) => ({
        ...styles,
        borderRadius: "4px",
        borderColor: state.isFocused && "#a5db7a",
        boxShadow: state.isFocused && "0 0 0 0.2rem rgba(0,123,255,.25)",
        width: "calc(100% - 8px)",
    }),
};

const errorStyles = {
    ...baseStyles,
    control: (styles, state) => ({
        ...styles,
        backgroundColor: state.isDisabled ? "#EEEEEE" : "white",
        margin: "-1.5px",
        borderColor: state.isFocused ? "lightgreen" : "#f44336",
        "&:hover": {
            borderColor: state.isFocused ? "lightgreen" : "#f44336",
        },
        font: "15px",
        color: "#262626",
        boxShadow: "none",
        minHeight: 32,
    }),
};

const SelectField = (props) => {
    const {
        fieldApi,
        label,
        options = [],
        isMulti = false,
        fullWidth,
        ...rest
    } = props;

    const { getValue, setValue, getError, setError } = fieldApi;

    const value = getValue();
    const error = getError();
    const hasError = !!error;

    const selectedValue = React.useMemo(() => {
        if (isMulti) {
            const vals =
                typeof value === "string" && value.length > 0
                    ? value.split(",").map((v) => v.trim())
                    : [];

            return options.filter((o) => vals.includes(o.value));
        } else {
            if (!value) return null;
            return options.find((o) => o.value === value) || null;
        }
    }, [value, options, isMulti]);

    const handleChange = (selected) => {
        let newValue;

        if (isMulti) {
            const vals = selected ? selected.map((o) => o.value) : [];
            newValue = vals.join(","); 
        } else {
            newValue = selected ? selected.value : "";
        }

        setValue(newValue);
        setError(null);    
    };

    return (
        <div style={fullWidth ? { width: "100%" } : {}}>
            {label && (
                <Typography style={{ marginTop: -3, marginBottom: 0 }}>
                    {label}
                </Typography>
            )}

            <Select
                isMulti={isMulti}
                value={selectedValue}
                onChange={handleChange}
                options={options}
                styles={hasError ? errorStyles : baseStyles}
                menuPortalTarget={document.body}
                {...rest}
            />

            {hasError && (
                <div style={{ color: "#f44336", fontSize: 11, marginTop: 2 }}>
                    {error}
                </div>
            )}
        </div>
    );
};

const ContactReactSelect = FormField(SelectField);
export default ContactReactSelect;
